import { createEntityActions } from 'modules/redux-store';

export const serviceAction = createEntityActions<'services', Service>(
  'services',
);
